import { HomeAttendancePage } from './HomeAttendancePage';
export default HomeAttendancePage;
